'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Conditional$package$$anon$1$$anon$11(evaluator$11) {
  this.KO = null;
  this.KO = evaluator$11;
}
export { $c_Lsamples_Conditional$package$$anon$1$$anon$11 as $c_Lsamples_Conditional$package$$anon$1$$anon$11 };
$p = $c_Lsamples_Conditional$package$$anon$1$$anon$11.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Conditional$package$$anon$1$$anon$11;
/** @constructor */
function $h_Lsamples_Conditional$package$$anon$1$$anon$11() {
}
export { $h_Lsamples_Conditional$package$$anon$1$$anon$11 as $h_Lsamples_Conditional$package$$anon$1$$anon$11 };
$h_Lsamples_Conditional$package$$anon$1$$anon$11.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.KO.h();
  return ((v instanceof $j_java$002elang$002e$002dObject.$c_s_Option) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Conditional$package$$anon$1$$anon$11 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Conditional$package$$anon$1$$anon$11, "samples.Conditional$package$$anon$1$$anon$11", ({
  oi: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Conditional$package$$anon$1$$anon$11 as $d_Lsamples_Conditional$package$$anon$1$$anon$11 };
